
import {defineComponent} from "vue";
import Color from "../inputs/Color.vue";
import ToggleButton from "../inputs/ToggleButton.vue";
import Fieldset from "../inputs/Fieldset.vue";
import ColorSample from "../global/ColorSample.vue";
import Space from "../global/Space.vue";
import GradientBlock from "./GradientBlock.vue";
import fontcolors from "../../constants/fontcolors";

export default defineComponent({
  components: {
    ToggleButton, ColorSample, Color, Space, Fieldset, GradientBlock,
  },
  props: {
    modelValue: {type: String, required: true},
    gradient: {type: Array, required: true},
    showDetails: {type: Boolean, required: true},
  },
  emits: [
    "update:modelValue", "update:gradient",
  ],
  data() {
    return {
      fontcolors,
    };
  },
});
